/*global google*/
/*
 * Copyright 2021 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import { createCustomEqual } from "fast-equals";
import { isLatLngLiteral } from "@googlemaps/typescript-guards";
const render = (status) => {
    return <h1>{status}</h1>;
};

const Maps = ({ latitud, longitud, descripcion, icon }) => {
    // const [clicks, setClicks] = React.useState([]);
    const [zoom, setZoom] = React.useState(12); // initial zoom
    const [center, setCenter] = React.useState({
        lat: latitud[0],
        lng: longitud[0],
    });
    // const onClick = (e) => {
    //     // avoid directly mutating state
    //     setClicks([...clicks, e.latLng]);
    //     console.log("hola")
    // };
    const onIdle = (m) => {
        console.log(m);
        setZoom(m.getZoom());
        setCenter(m.getCenter().toJSON());
    };
    console.log(latitud, longitud)
    return (<div style={{ display: "flex", height: "100%" }}>
        <Wrapper apiKey={process.env.REACT_APP_MAPS} render={render}>
            <Map center={center} onIdle={onIdle} zoom={zoom} style={{ flexGrow: "1", height: "100%" }}>
                {latitud.map((marker, index) => (
                    <Marker position={{ lat: marker, lng: longitud[index] }} title={descripcion[index]}
                        icon={icon && { url: icon[index]['URL'], scaledSize: new google.maps.Size(50, 50), shape: { coords: [25, 25, 25], type: 'circle' } }}
                        shape={{ coords: [25, 25, 25], type: 'circle' }}
                    />
                ))}
            </Map>
        </Wrapper>
        {/* Basic form for controlling center and zoom of map. */}
        {/* {form} */}
    </div>);
};
const Map = ({ onClick, onIdle, children, style, ...options }) => {
    const ref = React.useRef(null);
    const [map, setMap] = React.useState();
    React.useEffect(() => {
        if (ref.current && !map) {
            setMap(new window.google.maps.Map(ref.current, {}));
        }
    }, [ref, map]);
    // because React does not do deep comparisons, a custom hook is used
    // see discussion in https://github.com/googlemaps/js-samples/issues/946
    useDeepCompareEffectForMaps(() => {
        if (map) {
            map.setOptions(options);
        }
    }, [map, options]);
    React.useEffect(() => {
        if (map) {
            ["click", "idle"].forEach((eventName) => google.maps.event.clearListeners(map, eventName));
            if (onClick) {
                map.addListener("click", onClick);
            }
            if (onIdle) {
                map.addListener("idle", () => onIdle(map));
            }
        }
    }, [map, onClick, onIdle]);
    return (<>
        <div ref={ref} style={style} />
        {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                // set the map prop on the child component
                // @ts-ignore
                return React.cloneElement(child, { map });
            }
        })}
    </>);
};
const Marker = (options) => {
    const [marker, setMarker] = React.useState();
    React.useEffect(() => {
        if (!marker) {
            setMarker(new google.maps.Marker({
                shape: {
                    coords: [25, 25, 25], // x, y, radio
                    type: 'circle',
                },
            }));
        }
        // remove marker from map on unmount
        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);
    React.useEffect(() => {
        if (marker) {
            marker.setOptions(options);
        }
    }, [marker, options]);

    return null;
};
const deepCompareEqualsForMaps = createCustomEqual((deepEqual) => (a, b) => {
    if (isLatLngLiteral(a) ||
        a instanceof google.maps.LatLng ||
        isLatLngLiteral(b) ||
        b instanceof google.maps.LatLng) {
        return new google.maps.LatLng(a).equals(new google.maps.LatLng(b));
    }
    // TODO extend to other types
    // use fast-equals for other objects
    return deepEqual(a, b);
});
function useDeepCompareMemoize(value) {
    const ref = React.useRef();
    if (!deepCompareEqualsForMaps(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
function useDeepCompareEffectForMaps(callback, dependencies) {
    React.useEffect(callback, dependencies.map(useDeepCompareMemoize));
}

export default Maps

